const TABS_SELECTOR = '.js-tabs';
const TABLIST_SELECTOR = '[role="tablist"]';
const TABPANEL_SELECTOR = '[role="tabpanel"]';
const TAB_SELECTOR = '[role="tab"]';

function createTabs(element: HTMLElement) {
  const tabList = element.querySelector<HTMLElement>(TABLIST_SELECTOR);
  if (!tabList)
    return;

  const tabPanelElements
    = element.querySelectorAll<HTMLElement>(TABPANEL_SELECTOR);
  const tabs = tabList.querySelectorAll<HTMLButtonElement>(TAB_SELECTOR);
  let tabFocus = 0;

  for (const [index, tab] of tabs.entries()) {
    if (tab.getAttribute('aria-selected') === 'true') {
      tabFocus = index;
      tab.setAttribute('tabindex', '0');
    }
    else {
      tab.setAttribute('tabindex', '-1');
    }
  }

  function selectTab(tab: HTMLButtonElement) {
    const controlsId = tab.getAttribute('aria-controls');
    if (controlsId === null || controlsId === '')
      return;

    for (const t of tabs) {
      t.setAttribute('aria-selected', 'false');
      t.setAttribute('tabindex', '-1');
    }

    tab.setAttribute('aria-selected', 'true');
    tab.setAttribute('tabindex', '0');

    for (const panel of tabPanelElements) {
      panel.hidden = true;
    }

    element.querySelector(`#${controlsId}`)?.removeAttribute('hidden');

    tabFocus = Array.from(tabs).indexOf(tab);
  }

  function handleTabClick(e: Event) {
    selectTab(e.currentTarget as HTMLButtonElement);
  }

  function changeTab(e: KeyboardEvent) {
    let next: number | null = null;

    if (e.key === 'ArrowRight') {
      next = tabFocus + 1 >= tabs.length ? 0 : tabFocus + 1;
    }
    else if (e.key === 'ArrowLeft') {
      next = tabFocus - 1 < 0 ? tabs.length - 1 : tabFocus - 1;
    }
    else if (e.key === 'Home') {
      next = 0;
    }
    else if (e.key === 'End') {
      next = tabs.length - 1;
    }

    if (next === null)
      return;

    e.preventDefault();
    const tab = tabs[next];
    selectTab(tab);
    tab.focus();
  }

  for (const tab of tabs) {
    tab.addEventListener('click', handleTabClick);
  }

  tabList.addEventListener('keydown', changeTab);
}

export function initTabs() {
  const tabsElements = document.querySelectorAll<HTMLElement>(TABS_SELECTOR);

  for (const tabElement of tabsElements) {
    createTabs(tabElement);
  }
}
